module.exports = __webpack_public_path__ + "img/price.8bf128bf.png";